var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgPhoneCall1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_209411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0945 14.7586C15.0476 14.2848 14.7937 13.8615 14.3977 13.5973L11.7131 11.8077C11.0864 11.3901 10.2485 11.4745 9.7165 12.0055L8.85854 12.8707C8.66336 12.9386 7.76061 12.556 6.59828 11.3932C5.43545 10.2298 5.05798 9.33478 5.10741 9.15661L5.98751 8.27651C6.51897 7.74505 6.60239 6.9051 6.18526 6.27991L4.3957 3.59531C4.1315 3.19928 3.70819 2.94541 3.23442 2.89855C2.7596 2.85116 2.29716 3.01801 1.96085 3.35431L0.633212 4.68195C-1.18623 6.5014 1.18323 10.4997 4.33801 13.655C6.48275 15.7998 11.1762 19.4973 13.3111 17.3598L14.6387 16.0322C14.975 15.6964 15.1413 15.2319 15.0945 14.7586Z",
    fill: "url(#paint0_linear_4_209411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0898 0C9.79836 0 9.5625 0.235863 9.5625 0.527344C9.5625 0.818824 9.79836 1.05469 10.0898 1.05469C13.8698 1.05469 16.9453 4.13016 16.9453 7.91016C16.9453 8.20164 17.1812 8.4375 17.4727 8.4375C17.7641 8.4375 18 8.20164 18 7.91016C18 3.54825 14.4517 0 10.0898 0ZM10.0898 2.10938C9.79836 2.10938 9.5625 2.34524 9.5625 2.63672C9.5625 2.9282 9.79836 3.16406 10.0898 3.16406C12.707 3.16406 14.8359 5.29302 14.8359 7.91016C14.8359 8.20164 15.0718 8.4375 15.3633 8.4375C15.6548 8.4375 15.8906 8.20164 15.8906 7.91016C15.8906 4.71161 13.2884 2.10938 10.0898 2.10938ZM10.0898 4.21875C9.79836 4.21875 9.5625 4.45461 9.5625 4.74609C9.5625 5.03757 9.79836 5.27344 10.0898 5.27344C11.5437 5.27344 12.7266 6.45634 12.7266 7.91016C12.7266 8.20164 12.9624 8.4375 13.2539 8.4375C13.5454 8.4375 13.7812 8.20164 13.7812 7.91016C13.7812 5.87493 12.1251 4.21875 10.0898 4.21875ZM10.0898 6.32812C9.79836 6.32812 9.5625 6.56399 9.5625 6.85547C9.5625 7.14695 9.79836 7.38281 10.0898 7.38281C10.3808 7.38281 10.6172 7.6192 10.6172 7.91016C10.6172 8.20164 10.8531 8.4375 11.1445 8.4375C11.436 8.4375 11.6719 8.20164 11.6719 7.91016C11.6719 7.03779 10.9622 6.32812 10.0898 6.32812Z",
    fill: "url(#paint1_linear_4_209411)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_209411",
    x1: 7.55112,
    y1: 18.0028,
    x2: 7.55112,
    y2: 2.89057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5558FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_209411",
    x1: 13.7812,
    y1: 8.4375,
    x2: 13.7812,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_209411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgPhoneCall1);
export default __webpack_public_path__ + "static/media/svg_phone_call_1.5aa163657e0f46d849a94eed78f80032.svg";
export { ForwardRef as ReactComponent };